import {DescriptionText, FlexContainer, H1Text, H2Text} from "../../../../design";
import React from "react";
import {AmountDivideByHundred} from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyformatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object,
  whiteLabel: Boolean,
  bankImageUrl: String,
  cancelUrlLink: String,
}

const Header = (props:Props) => {
  const { payment, bankImageUrl, whiteLabel, cancelUrlLink } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  
  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  // const customPrimaryHeadingProps = {
  //   fontWeight: 'bold',
  //   marginTop: '5px',
  //   marginBottom: '5px',
  //   fontSize: '20px',
  // };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  
  return (
    <SmallScreenHeader 
      paymentCheckout={true} 
      bankImageUrl={bankImageUrl} 
      largeLogo={largeLogo} 
      whiteLabel={whiteLabel}
      cancelUrlLink={cancelUrlLink}
    >
      <FlexContainer {...customContainerProps}>
        {/* <H1Text>
          woocommerce
        </H1Text> */}
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Payment For
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {payment && payment.description}
          </DescriptionText>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Amount Payable
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {payment ? `${currencyformatter(AmountDivideByHundred(payment.amount), payment.currency && payment.currency.name)}` : null }
          </DescriptionText>
        </FlexContainer>
      </FlexContainer>
    </SmallScreenHeader>
  )
};

export default Header;
